import { SettingCardRow } from '@components/Dashboard/components'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { OptionsContent, SelectButton } from './components'

interface Option {
  value: string
  label: string
}

interface Props {
  label: string
  value: string
  options: Option[]
  onChange: (value: string) => void
  icon?: React.FC
  // a line under the label, e.g. what the choice does not affect
  description?: string
}

const Empty: React.FC = () => null

export const MenuRow: React.FC<Props> = ({
  label,
  value,
  options,
  onChange,
  icon = Empty,
  description = '',
}) => {
  const selectedLabel =
    options.find((option) => option.value === value)?.label ?? ''

  const handleClick = (path: string[]) => onChange(path[0])

  return (
    <SettingCardRow title={label} description={description} titleCenter>
      <DropdownMenu.Root
        onClick={handleClick}
        content={OptionsContent}
        options={options}
        active={value}
        width="wide"
      >
        <SelectButton title={selectedLabel} placeholder={label} icon={icon} />
      </DropdownMenu.Root>
    </SettingCardRow>
  )
}
